
namespace TabAurous.Reports {
    
    @Serenity.Decorators.registerClass()
    export class JobTransactionGrid extends Serenity.EntityGrid<TabAurous.Stock.JobTransactionRow, any> {
        protected getColumnsKey() { return 'Stock.JobTransaction'; } 
        protected getIdProperty() { return TabAurous.Stock.JobTransactionRow.idProperty; }
        protected getInsertPermission() { return TabAurous.Stock.JobTransactionRow.insertPermission; }
        protected getLocalTextPrefix() { return TabAurous.Stock.JobTransactionRow.localTextPrefix; }
        protected getService() { return TabAurous.Stock.JobTransactionService.baseUrl; }

        private chartContainer: JQuery;
        private chartPanel: Reports.LineChartPanel;
        constructor(container: JQuery) {
            super(container);
            this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.FinancialYearRow.lookupKey,
                    multiple: true

                },
                field: 'FinancialYearId',
                title: 'Year',
                handler: w => {
                    var temp= [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).FinancialYearIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    }
                },
                
                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.CompanyRow.lookupKey,
                    multiple: true

                },
                field: 'CompanyId',
                title: 'Company',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).CompanyIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: "VendorLKUP",
                    multiple: true

                },
                field: 'PartyId',
                title: 'Party',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).VendorIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
          

            return filters;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
            this.view.setGrouping([{

                getter: 'ProductCode',
                displayTotalsRow: false,
            }, {
                    getter: 'LineNo',
                    displayTotalsRow: false,
                }])
            return grid;
        }
         
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push({

                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {
                    
                    Common.ReportHelper.execute({
                        reportKey: 'Reports.ApprovalRegister',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                            VendorIds: this.view.params.VendorIds,
                            date:this.view.params.Criteria
                        }
                    });
                }
            });
            return buttons;
        }
    }
}